module.exports = __webpack_public_path__ + "static/media/ke.eb56b0fb.svg";